module.exports = "../study/imgs/maps/Tokyo/S8/Helth/HeatStress/Tokyo_HeatStress_MIROC5_RCP45_Now.png";